import { Component } from "react";
import View from "./view";

class Stores extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return View.call(this);
  }
}

export default Stores;



// WEBPACK FOOTER //
// ./src/screens/stores/index.js